var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileRegular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_275_9331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0292969 2.75C0.0292969 1.23105 1.22305 0 2.69596 0H9.5918C10.3001 0 10.9751 0.289738 11.4751 0.805664L15.2501 4.69648C15.7501 5.21211 16.0293 5.9082 16.0293 6.63867V19.25C16.0293 20.7668 14.8335 22 13.3626 22H2.69596C1.22305 22 0.0292969 20.7668 0.0292969 19.25V2.75ZM14.0293 19.25V6.875H10.696C9.95846 6.875 9.36263 6.26055 9.36263 5.5V2.0625H2.69596C2.32763 2.0625 2.0293 2.37016 2.0293 2.75V19.25C2.0293 19.6281 2.32763 19.9375 2.69596 19.9375H13.3626C13.7293 19.9375 14.0293 19.6281 14.0293 19.25Z",
    fill: "#595959"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_275_9331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 22,
    fill: "white",
    transform: "translate(0.0292969)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileRegular);
export default __webpack_public_path__ + "static/media/file-regular.e312724b9101a85b74fea947524d0b3b.svg";
export { ForwardRef as ReactComponent };